import Message from 'components/Message'
import DrupalContext from 'contexts/DrupalContext'
import useDefaultParams from 'hooks/useDefaultParams'
import React, { useContext } from 'react'
import General from 'views/types/General.js'
import Niche from 'views/types/Niche'
import Widget from 'views/types/Widget'

function App() {
  const drupal = useContext(DrupalContext)
  const {type} = drupal

  useDefaultParams()

  switch (type) {
    case 'general': // global search
      return <General />
    case 'page': // niche search
      return <Niche />
    case 'widget': // search box only
      return <Widget />
    default:
      return (<Message message={<p>Searcher view type <b>"{type}"</b> not found.</p>} error />)
  }
}

export default App
